// extracted by mini-css-extract-plugin
export default {"slideshowContainer":"slideshow_slideshowContainer__gqMiF","asideExpanded":"slideshow_asideExpanded__IsTOR"};